import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: any) => ({
    modal_container: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        padding: theme.spacing(2),
    },
    input: {
        marginBottom: theme.spacing(1),
    },
    alert: {
        marginBottom: theme.spacing(1),
    },
    btn_container: {
        width: "100%",
        display: "flex",
        justifyContent: "end"
    }
}));
